export const claddingCellGap: number = Autodesk.Viewing.Private.convertUnits("inch", "ft", 1, 0.5);

export const editorCladdingGeometryThickness = 0.02;
export const libraryLengthsToleranceDecimalSigns = 3;

export const defaultOffsetY = Autodesk.Viewing.Private.convertUnits("mm", "ft", 1, 176.7);
